import { calculateMileageFlags } from "helpers/enums";
import { getInitialStateFromConfig } from "helpers/form";
import { requiredField } from "helpers/validators";
import moment from "moment";

const config = {
    carIds: {
        // field
        label: "Грузовики",
        inputProps: { name: "carIds" },
        propName: "number",
        validators: [requiredField],
        required: true,
    },
    from: {
        // date field
        label: "Дата начала",
        inputProps: { name: "from", type: "date" },
        validators: [requiredField],
        required: true,
        libOptions: {
            maxDate: moment(),
            isClearable: true,
        },
    },
    to: {
        // date field
        label: "Дата окончания",
        inputProps: { name: "to", type: "date" },
        validators: [requiredField],
        required: true,
        libOptions: {
            maxDate: moment().add(1, "d"),
            isClearable: true,
        },
    },
    intCalculateFlags: {
        // flags
        label: "Опции",
        inputProps: { name: "intCalculateFlags" },
        validators: [requiredField],
        value: 0,
        flags: calculateMileageFlags,
        required: true,
    },
};

const initialState = getInitialStateFromConfig(config);

export { config, initialState };
